export const config1 = {
  chart: {
    type: 'areaspline',
    backgroundColor: "#EFEFEF"
  },
  title: {
    text: null
  },
  xAxis: {
    categories: []
  },
  yAxis: {
    tickAmount: 8,
  },
  tooltip: {
    formatter: function () {
      return '<b>' + this.series.name + '</b><br/>' +
        this.x + ': ' + this.y;
    }
  },
  credits: {
    enabled: false
  },
  plotOptions: {},
  series: [{
    name: "Receive",
    data: []
  },{
    name: "Send",
    data: []
  }],
  // legend: {
  //   layout: 'vertical',
  //   backgroundColor: '#E4E4E4',
  //   floating: true,
  //   align: 'left',
  //   x: 58,
  //   y: -10,
  //   verticalAlign: 'top'
  // }
  legend: {
    width: 160,
    layout: 'horizontal',
    backgroundColor: '#E4E4E4',
    floating: false,
    align: 'left',
    x: 58,
    y: -10,
    verticalAlign: 'top'
  }
};
export const config2 = {
  colors:["rgb(124, 181, 236)","rgb(247, 163, 92)"],
  chart: {
    type: 'pie',
    backgroundColor: "#EFEFEF",
    options3d: {
      enabled: true,
      alpha: 45,
      beta: 0
    }
  },
  title: {
    text: 'Subscription Status'
  },
  tooltip: {
    pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
  },
  plotOptions: {
    pie: {
      innerSize: 100,
      allowPointSelect: true,
      cursor: 'pointer',
      depth: 45,
      dataLabels: {
        enabled: false,
        format: '{point.name}'
      },
      showInLegend: true
    }
  },
  series: [{
    type: 'pie',
    name: 'Subscriber',
    data: [
      ['Subscribed'],
      ['Unsubscribed']
    ]
  }],
  credits: {
    enabled: false
  },
  legend: {lineHeight: 10}
};
export const config3 = {
  colors:["rgb(144, 237, 125)", "rgb(128, 133, 233)"],
  chart: {
    type: 'pie',
    backgroundColor: "#EFEFEF",
    options3d: {
      enabled: true,
      alpha: 45,
      beta: 0
    }
  },
  title: {
    text: 'Subscription Actions'
  },
  tooltip: {
    pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
  },
  plotOptions: {
    pie: {
      innerSize: 100,
      allowPointSelect: true,
      cursor: 'pointer',
      depth: 45,
      dataLabels: {
        enabled: false,
        format: '{point.name}'
      },
      showInLegend: true
    }
  },
  series: [{
    type: 'pie',
    name: 'Subscriber',
    data: [
      ['Enable'],
      ['Disable']
    ]
  }],
  credits: {
    enabled: false
  },
  legend: {lineHeight: 10}
};
export const config4 = {
  chart: {
    type: 'column',
    backgroundColor: "#EFEFEF",
    margin: 75
  },
  title: {
    text: 'New subscribers'
  },
  xAxis: {
    categories: []
  },
  plotOptions: {
    column: {
      depth: 35,
      pointWidth: 25
    }
  },
  credits: {
    enabled: false
  },
  series: [{
    name: "New subscriber",
    data: []
  }],
  legend: {
    layout: 'vertical',
    backgroundColor: '#E4E4E4',
    floating: true,
    align: 'left',
    x: 58,
    verticalAlign: 'top',
    y: -10
  },
};


// WEBPACK FOOTER //
// ./src/container/dashboard/model/data.js